import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 68px;
  padding: 0 15%;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.white};

  .logo-header {
    display: flex;
    align-items: center;
    width: 128px;
    @media (min-width: 769px) {
      width: 147px;
    }
  }

  ul {
    display: flex;
    flex: 1;
    margin: 0 1.93%;
    padding: 0;
    justify-content: flex-end;
    align-items: center;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      list-style: none;
      margin-left: 24px;

      &:hover:not(:last-child) {
        text-decoration: none;
      }

      a {
        color: rgb(33, 37, 41);
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        font-family: "Maison Neue Medium", sans-serif;
        text-decoration: none;
        margin: 0 5px;
      }
    }
  }

	.social-icon {
		height: 18px;
		width: 18px;
	}

  .button-menu-header {
		font-family: "Maison Neue Medium", sans-serif;

		&:hover {
      background: ${({ theme }) => theme.black};
      color: ${({ theme }) => theme.white};
    }

		border: 1px solid rgb(77, 76, 77);
    padding: 7px 15px
  }
`;

export const ContainerMobile = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.white};
	margin-top: -24px;

  ul {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;

    li {
      padding: 16px 13px;
      list-style: none;
      background: ${({ theme }) => theme.white};

      &.login-container-mobile {
        background: ${({ theme }) => theme.purplePrimary};;

        a {
          color: ${({ theme }) => theme.white};
          font-weight: 400;
        }
      }

      &.header-logout {
        margin-top: auto;
        span {
          display: flex;
          align-items: center;
          gap: 5px;
          font-size: 1.2rem;
          font-weight: 500;
          color: ${({ theme }) => theme.purplePrimary};;
        }
      }

      a {
        font-size: 16px;
        color: #6d6d6d;
        font-weight: 400;
        font-family: "Maison Neue Medium", sans-serif;

        &:hover {
          color: #031d3d;
          transition: color 0.2s;
        }
      }
    }
  }
`;
